function ridToId (recordOrRid) {
  if (!recordOrRid) return null;
  var rid = recordOrRid['@rid'] || recordOrRid;
  rid = String(rid);
  return rid.charAt(0) === '#' ? rid.slice(1) : rid;
}

function pathRecord (resourceRecord, className) {
  return (Array.isArray(resourceRecord && resourceRecord.path) ? resourceRecord.path : [])
    .find(function (record) { return record && record['@class'] === className; });
}

function formatInterval (value) {
  var seconds = Number(value);
  if (!Number.isFinite(seconds)) return 'Unknown';
  if (seconds === 0) return 'No sampling';
  if (seconds % 60 === 0) {
    var minutes = seconds / 60;
    return minutes + ' minute' + (minutes === 1 ? '' : 's') + ' (' + seconds + ' seconds)';
  }
  return seconds + ' second' + (seconds === 1 ? '' : 's');
}

function editor (resourceRecord) {
  var resourceClass = resourceRecord && resourceRecord['@class'];
  var protocol;
  var device;

  if (resourceClass === 'BacnetProperty') {
    protocol = 'BACnet';
    device = pathRecord(resourceRecord, 'BacnetDevice');
    if (device) {
      return {
        protocol: protocol,
        href: '/bacnetdevice/' + ridToId(device),
        label: 'Edit BACnet poll groups'
      };
    }
  }

  if (resourceClass === 'ModbusAddress') {
    protocol = 'Modbus';
    device = pathRecord(resourceRecord, 'ModbusDevice');
    if (device) {
      return {
        protocol: protocol,
        href: '/modbusdevice/' + ridToId(device),
        label: 'Edit Modbus poll groups'
      };
    }
  }

  return {
    protocol: protocol || 'network',
    href: null,
    label: 'Edit poll groups'
  };
}

function details (resourceRecord) {
  var groups = Array.isArray(resourceRecord && resourceRecord.samplingPollGroups)
    ? resourceRecord.samplingPollGroups.filter(Boolean)
    : [];
  if (!groups.length) return null;

  return {
    groups: groups,
    editor: editor(resourceRecord)
  };
}

module.exports = {
  details: details,
  formatInterval: formatInterval
};
